import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ANGULAR_MODULES, SYNCFUSION_MODULES } from '../shared-imports';
import { SortService } from '@syncfusion/ej2-angular-grids';
import { DatePipe } from '@angular/common';
import { customCurrencyPipe } from '../customCurrency.pipe';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PaymentService } from 'src/app/services/payment.service';
import { lastValueFrom, Subject, Subscription, take, takeUntil } from 'rxjs';
import { CreditCardTypeService } from 'src/app/services/creditcardtype';
import { OperationRentalService } from 'src/app/services/Rentals.service';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { PaymentComponent } from '../payment/payment.component';
import { LoaderComponent } from '../loader/loader.component';
import { SharedHTMLSettingsDataService } from '../sharedHTMLSettingsData.service';
import { CommonCalculatorService } from '../commonCalculators.service';
import { PrinterSettingsService } from 'src/app/services/printer-settings.service';
import { UserService } from 'src/app/services/User.service';
import { GeneralService } from 'src/app/services/general.service';
import { DayEndService } from 'src/app/services/DayEnd.service';
import { VendorService } from 'src/app/services/Vendor.service';
import { PhoneFormatPipe } from '../phone-format.pipe';
import { WordReplacePipe } from '../word-replace.pipe';
import { RentalSettingService } from 'src/app/services/RentalSetting.service';
import { StripePaymentComponent } from '../../Shared/stripe-payment/stripe-payment.component';
import { EPaymentGateway } from '../../Shared/enum';

@Component({
  selector: 'app-rental-pay-bybooth',
  standalone: true,
  imports: [ANGULAR_MODULES, SYNCFUSION_MODULES, PaymentComponent, LoaderComponent, PhoneFormatPipe, WordReplacePipe,StripePaymentComponent],
  providers: [SortService],
  templateUrl: './rental-pay-bybooth.component.html',
  styleUrl: './rental-pay-bybooth.component.scss'
})
export class RentalPayByboothComponent implements OnInit, OnDestroy {
  paymentForm: FormGroup;
  keyedInTransaction = false;
  creditCardList = [];
  allCreditCards = [];
  @Input() vendorId;
  @Input() PriorBalance = 0;
  warnExcessPayment;
  warnZeroPayment;
  disablePayBtnAfterSubmit = false;
  calculateChangeAmount;
  public loaderIcon: Promise<boolean>;
  processPayment = false;
  IsStrip = false;
  IsOpenEdgeExpress = false;
  creditCardAmount;
  voidPayment = false;
  verifoneId = "";
  printThermalReceipt = false;
  thermalReceiptCopies = 0;
  rentalMerchantCopy = false;
  rentalMerchantNoOfCopies = 0;
  rentalCustomerCopy = false;
  rentalCustomerNoOfCopies = 0;
  @ViewChild('checkNo') checkNo: ElementRef;
  transactionType = "CREDITSALE";
  userId;
  companyId;
  isRentalCashRoundingEnabled: boolean = false;
  isCashModeActive: boolean = false;
  rentalNotes = "";
  finalRentalNotes = "";
  vendorComment = "";
  finalVendorComment = "";
  chargeCCProcessingFee = false;
  displayApplyCredit = false;

  get ccChargeDisplay(): string {
    const paymentDetails = this.paymentForm?.get('paymentDetails');
    if (!paymentDetails) return this.customCurrency.transform('0.00');

    const creditCardAmount = this.commonCalculatorService.getActualAmountFromInp(paymentDetails.get('creditCardAmount')?.value) || 0;
    const convenienceFee = this.commonCalculatorService.getActualAmountFromInp(paymentDetails.get('convenienceFee')?.value) || 0;
    const ccCharge = creditCardAmount + convenienceFee;

    return this.customCurrency.transform(ccCharge.toString());
  }

  constructor(private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    private paymentService: PaymentService,
    private creditCardTypeService: CreditCardTypeService,
    private customCurrency: customCurrencyPipe,
    private toastr: ToastrService,
    private operationRentalService: OperationRentalService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
    private commonCalculatorService: CommonCalculatorService,
    private printerService: PrinterSettingsService,
    private userService: UserService,
    private generalService: GeneralService,
    private dayendService: DayEndService,
    private vendorService: VendorService,
    private rentalService: RentalSettingService
  ) {
    this.paymentForm = this.formBuilder.group({
      displayReceipt: [false],
      printReceipt: [false],
      emailReceipt: [false],
      paymentDetails: this.formBuilder.group({
        cashAmount: this.customCurrency.transform('0.00'),
        checkAmount: this.customCurrency.transform('0.00'),
        creditCardAmount: this.customCurrency.transform('0.00'),
        directDebitAmount: this.customCurrency.transform('0.00'),
        changeAmount: this.customCurrency.transform('0.00'),
        balanceAmount: this.customCurrency.transform('0.00'),
        vendorBalance: this.customCurrency.transform('0.00'),
        totalDue: this.customCurrency.transform('0.00'),
        creditCards: [{ value: '1', disabled: true }],
        checkNo: [{ value: '', disabled: true }],
        keyedInTransaction: [{ value: false, disabled: true }],
        ExistingCredit: [{ value: '$0.00', disabled: true }],
        applyCredit: [false],
        roundingAmount: [{ value: '$0.00', disabled: true }],
        convenienceFee: [{ value: '$0.00', disabled: true }],
        priorARBalance: [{ value: '$0.00', disabled: true }]
      })
    })
    this.paymentForm.get('paymentDetails.cashAmount')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.handleCashManualInput();
      });
  }
  private subscriptions: Subscription[] = [];
  creditCardTypes = [];
  rentalDues = [];
  otherRentalDues = [];
  fullRentalDues: any[] = [];
  totalVendorBalance = 0;
  fullOtherRentalDues
  @Input() rentalData;
  @Input() Dues = [];
  @Input() rentalType;
  @Output() closePayByBooth = new EventEmitter<any>();
  @Output() paymentCompleted = new EventEmitter<any>();
  @Output() cancelPayByBooth = new EventEmitter<any>();
  accountReceiptIds = [];
  selectedReceiptIds;
  paymentGatewayCredentials;
  processCreditCardOnline;
  selectedIdsSet: Set<number> = new Set<number>();
  uniqueSessionId = "";
  terminalNoSet = false;
  dayendProcessedForToday = false;
  private destroy$ = new Subject<void>();
  vendorInfo: any;
  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (['F2', 'F3', 'F4', 'F5'].includes(event.key)) {
      event.preventDefault();
      this.paymentForm.controls['paymentDetails'].patchValue({
        cashAmount: this.customCurrency.transform("0"),
        checkAmount: this.customCurrency.transform("0"),
        creditCardAmount: this.customCurrency.transform("0"),
        directDebitAmount: this.customCurrency.transform("0")
      })
      if (event.key === 'F2' && this.isRentalCashRoundingEnabled) {
        this.isCashModeActive = true;
      }
      else {
        this.deactivateCashRounding();
      }

      var totalDue = this.paymentForm.controls['paymentDetails'].get('totalDue').value;
      switch (event.key) {
        case 'F2':
          const dueAmount = Number(this.commonCalculatorService.getActualAmountFromInp(totalDue));
          const roundedAmount = this.applyCashRoundingIfEnabled(dueAmount);
          this.paymentForm.controls['paymentDetails'].get('cashAmount').setValue(this.customCurrency.transform(roundedAmount.toString()));
          break;
        case 'F3':
          this.paymentForm.controls['paymentDetails'].get('checkAmount').setValue(totalDue);
          break;
        case 'F4':
          this.paymentForm.controls['paymentDetails'].get('creditCardAmount').setValue(totalDue);
          break;
        case 'F5':
          this.paymentForm.controls['paymentDetails'].get('directDebitAmount').setValue(totalDue);
          break;
      }

      if (event.key === 'F4') {
        this.calculateConvenienceFee();
      } else {
        this.calculatePaymentDistribution();
      }
    }
  }

  ngOnInit(): void {
    this.getCompanyId();
    this.checkDayEndProcessForLoggedInUser();
    this.getVendorInfo();
    this.getVendorBoothCredit();
    const tabId = sessionStorage.getItem('tabId');
    const sessionKey = `UniqueSessionId-${tabId}`;
    this.uniqueSessionId = localStorage.getItem(sessionKey);
    this.paymentForm.controls['paymentDetails'].get('priorARBalance').setValue(this.customCurrency.transform(this.PriorBalance.toString()));
    this.getDefaultRentalNotes();
    this.getVendorComment();
    this.getDefaultTerminalId();
    this.getRentalSettings();    
    this.getCCCredentials();
    this.getAllCreditCardsByMarket();
    this.getCreditCardFeeSettings();
    this.getReceiptCheckBoxSettings();
    if (this.Dues != null) {
      this.getDueRecordsFromRentalList();
    }
  }

  getCompanyId() {
    this.generalService.getCompanyId().pipe(take(1)).subscribe(res => {
      if (res) {
        this.companyId = res.Id;
      }
    });
  }

  shouldApplyExistingCredit(): boolean {
    if (!this.displayApplyCredit) return true;
    return !!this.paymentForm.get('paymentDetails.applyCredit')?.value;
  }

  getVendorInfo() {
    this.vendorService.GetVendorById(this.vendorId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        if (res) this.vendorInfo = res;
      });
  }

  getDefaultRentalNotes() {
    const sub = this.operationRentalService.getDefaultRentalNotes().subscribe((response: string) => {
      if (response) {
        this.rentalNotes = response;
        this.finalRentalNotes = response;
        //this.defaultRentalNotes = response;
      }
    },
      (err) => {
        console.error('Error in getDefaultRentalNotes', err);
      });
    this.subscriptions.push(sub);
  }

  bindRentalNotes() {
    this.rentalNotes = this.finalRentalNotes;
  }

  saveRentalNotes() {
    this.finalRentalNotes = this.rentalNotes;
  }

  getVendorComment() {
    this.subscriptions.push(this.vendorService.getVendorComment(this.vendorId).subscribe((response) => {
      if (response) {
        this.vendorComment = response.body.Comment;
        this.finalVendorComment = response.body.Comment;
      }
    }));
  }

  bindVendorComments() {
    this.vendorComment = this.finalVendorComment;
  }

  saveVendorComments() {
    this.finalVendorComment = this.vendorComment;
  }

  getReceiptCheckBoxSettings() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.printerService.getRentalPrinterSettings().subscribe((res: any) => {
      if (res) {
        this.paymentForm.patchValue
          ({
            displayReceipt: res.ReceiptDefaultChecked,
            printReceipt: res.PrintReceipt,
            emailReceipt: res.EmailReceipt
          })
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  getVendorBoothCredit() {
    this.operationRentalService.getVendorBoothCredit(this.vendorId)
      .pipe(take(1))
      .subscribe({
        next: res => {
          if (res) {
            this.displayApplyCredit = res.DisplayApplyCredit;
            var creditAmount = res.DisplayApplyCredit ? res.CreditAmount ?? 0 : 0;
            if(!this.displayApplyCredit && this.PriorBalance < 0) {
              creditAmount = (-1) * this.PriorBalance;
            }
            this.paymentForm.controls['paymentDetails'].get('ExistingCredit').setValue(this.customCurrency.transform(creditAmount));

            if (!this.displayApplyCredit) {
              this.paymentForm.controls['paymentDetails'].get('applyCredit')?.setValue(true, { emitEvent: false });
            }

            this.calculatePaymentDistribution();
          }
        },
        error: err => {
          console.error('Failed to load vendor booth credit', err);
        }
      })
  }

  checkDayEndProcessForLoggedInUser() {
    this.dayendService.checkDayEndProcessForLoggedInUser().subscribe(async (res) => {
      if (res !== null && res.Status) {
        this.dayendProcessedForToday = true;
      }
    })
  }

  getDefaultTerminalId() {
    this.userService.getDefaultTerminalId()
      .pipe(take(1))
      .subscribe(res => {
        if (res && res != 0) {
          this.terminalNoSet = false;
        } else {
          this.terminalNoSet = true;
          this.toastr.info($localize`User Default Terminal Not Set`, $localize`Info`, this.sharedHTMLSettings.ToasterConfig);
        }
      })
  }

  getRentalSettings() {
    this.rentalService.getRentalSettings().pipe((takeUntil(this.destroy$))).subscribe({
      next: (res: any) => {
        this.isRentalCashRoundingEnabled = res?.PaymentSettings?.IsRentalCashRounding ?? false;        
        this.calculateChangeAmount = res?.PaymentSettings?.CalculateChange ?? false;
      },
      error: err => {
        console.error('Failed to load rental settings', err);
      }
    });
  }

  getDueRecordsFromRentalList() {
    var duesRecord = this.Dues;
    this.accountReceiptIds = Array.from(
      new Set(
        duesRecord
          .filter(e => e.MarketAccountReceiptId != null && e.MarketAccountReceiptId !== 0)
          .map(e => e.MarketAccountReceiptId)
      )
    );
    this.selectedReceiptIds = this.accountReceiptIds.map(() => true);
    this.selectedIdsSet = new Set(this.accountReceiptIds);

    this.rentalDues = duesRecord
      .filter(e => e.ChargeType === "R")
      .map(e => ({
        BoothNum: e.RentalBoothOrOtherID,
        TrxDate: this.datePipe.transform(e.TransactionDate, 'MM/dd/yyyy'),
        Tax1: this.customCurrency.transform(e.Tax1),
        Tax2: this.customCurrency.transform(e.Tax2),
        RentalPeriod: e.RentalPeriod,
        Rent: this.customCurrency.transform(e.CurrentAmount),
        Paid: this.customCurrency.transform(e.PaidTill),
        Due: this.customCurrency.transform(((e.CurrentAmount + (e.Tax1 ?? 0) + (e.Tax2 ?? 0)) - (e.PaidTill ?? 0)).toString()),
        Payment: this.customCurrency.transform("0"),
        CrAmt: this.customCurrency.transform("0"),
        AccountReceiptId: e.AccountReceiptId,
        MarketAccountReceiptId: e.MarketAccountReceiptId,
        RentalId: e.RentalId,
        RentalPeriodToDisp: e.RentalPeriodToDisp
      }));

    this.otherRentalDues = duesRecord
      .filter(e => e.ChargeType === "O")
      .map(e => ({
        OtherItem: e.OtherItem,
        BoothNum: e.OtherBoothNumber,
        TrxDate: this.datePipe.transform(e.TransactionDate, 'MM/dd/yyyy'),
        RentalPeriod: e.RentalPeriod,
        Rent: this.customCurrency.transform(e.CurrentAmount),
        Tax1: this.customCurrency.transform(e.Tax1),
        Tax2: this.customCurrency.transform(e.Tax2),
        Paid: this.customCurrency.transform(e.PaidTill),
        Due: this.customCurrency.transform(((e.CurrentAmount + (e.Tax1 ?? 0) + (e.Tax2 ?? 0)) - (e.PaidTill ?? 0)).toString()),
        Payment: this.customCurrency.transform("0"),
        CrAmt: this.customCurrency.transform("0"),
        AccountReceiptId: e.AccountReceiptId,
        MarketAccountReceiptId: e.MarketAccountReceiptId,
        RentalBoothOrOtherID: e.RentalBoothOrOtherID,
        RentalId: e.RentalId,
        RentalPeriodToDisp: e.RentalPeriodToDisp
      }));

    var totalDue = duesRecord.reduce((sum, a) => {
      let totalValue = ((a.CurrentAmount ?? 0) + (a.Tax1 ?? 0) + (a.Tax2 ?? 0)) - (a.PaidTill ?? 0);
      return this.normalizeMoney(sum + this.normalizeMoney(totalValue));
    }, 0);

    var vendorBalance = totalDue;
    this.totalVendorBalance = totalDue;

    if (!this.rentalData) {
      vendorBalance = (this.PriorBalance ?? 0);
      this.totalVendorBalance = (this.PriorBalance ?? 0);
    }
    else if (this.PriorBalance > 0) {
      vendorBalance = vendorBalance + (this.PriorBalance ?? 0)
      this.totalVendorBalance = this.totalVendorBalance + (this.PriorBalance ?? 0)
    }

    vendorBalance = this.customCurrency.transform(vendorBalance);
    totalDue = this.customCurrency.transform(totalDue);

    this.fullRentalDues = this.rentalDues;
    this.rentalDues = [...this.fullRentalDues];

    this.fullOtherRentalDues = this.otherRentalDues;
    this.otherRentalDues = [...this.fullOtherRentalDues];

    this.paymentForm.controls['paymentDetails'].patchValue({
      totalDue: totalDue,
      balanceAmount: totalDue,
      vendorBalance: vendorBalance
    })
  }

  getCCCredentials() {
    this.paymentService.getCCCredentials().subscribe((res) => {
      if (res !== null) {
        this.paymentGatewayCredentials = res.GatewayDetails ? JSON.parse(res.GatewayDetails) : null;
        this.processCreditCardOnline = res.ProcessCreditCardOnline;
        //added below code for switching Payment gate way
        if (res.PaymentGateWay == EPaymentGateway.Stripe) {
          this.IsStrip = true;
        } else if (res.PaymentGateWay == EPaymentGateway.OpenEdgeExpress) {
          this.IsOpenEdgeExpress = true;
        }
      }
    })
  }

  getAllCreditCardsByMarket() {
    this.loaderIcon = Promise.resolve(true);
    this.creditCardTypeService.GetAllCreditCardsByMarket()
      .pipe(take(1)).subscribe((res: any) => {
        this.creditCardList = res.filter(el => !el.IsInactive).map((el, i) => ({
          CreditCardTypeId: el.CreditCardTypeId,
          CreditCardTypeDesc: el.CompanyCreditCardTypeDesc,
          ChargeType: el.ChargeType,
          Charge: el.Charge,
          CreditCardType: el.CardType,
          MarketId: el.MarketId
        }));
        this.allCreditCards = this.creditCardList;
        this.paymentForm.controls['paymentDetails'].get('creditCards').setValue(this.creditCardList[0]?.CreditCardTypeId);
        this.loaderIcon = Promise.resolve(false);
      }, err => {
        this.loaderIcon = Promise.resolve(false);
      });
  }

  ClosePaymentPage() {
    this.processPayment = false;
    this.voidPayment = false;
    this.disablePayBtnAfterSubmit = false;
  }

  handleClick(event: any) {
    this.commonCalculatorService.handleClick(event);
  }

  numberOnlyForCash(event: any) {
    // Get the current value of the input field
    const currentValue: string = event.target.value;
    const currentCursorPosition = event.target.selectionStart;
    const currentSelectionLength = event.target.selectionEnd - event.target.selectionStart;
    if (currentSelectionLength === currentValue.length) {
      return true;
    }
    // Check if the input value is "0" and if it contains a "$" sign
    if (currentValue === '0' && !currentValue.includes('$')) {
      // Set the new value with "$" sign
      event.target.value = '$0';
      // Set the cursor position after the "$" sign
      event.target.setSelectionRange(1, 1);
      return;
    }
    // Check if the "$" sign is present in the current value
    const hasDollarSign = currentValue.includes('$');
    // Allow input if the "$" sign is not present
    if (!hasDollarSign) {
      return;
    }
    // Get the cursor position
    const caretPosition = event.target.selectionStart;
    // Check if the cursor position is after the "$" sign
    const hasDollarSignBeforeCaret = currentValue.slice(0, caretPosition).includes('$');
    // If the cursor is not after the "$" sign, prevent input
    if (!hasDollarSignBeforeCaret) {
      event.preventDefault();
      return;
    }

    // Allow digits, a dot, and an optional '-' at the beginning
    const pattern = /^-?\d*\.?\d*$/;
    // Get the character entered by the user
    const inputChar = String.fromCharCode(event.charCode);
    // Check if the input matches the pattern
    if (!pattern.test(inputChar) || // If the entered character is not allowed
      (inputChar === '.' && currentValue.includes('.')) || // Or if the dot is already present
      (inputChar === '-' && currentValue.indexOf('-') !== -1)) { // Or if '-' is entered more than once
      event.preventDefault(); // Prevent the character from being entered
    }
  }

  getRentalPaymentSettings() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.operationRentalService.getRentalSettings().subscribe((res: any) => {
      if (res) {
        this.warnExcessPayment = res.WarnExcessPayment;
        this.warnZeroPayment = res.WarnZeroPayment;
        this.isRentalCashRoundingEnabled = res?.PaymentSettings?.PaymentSettings ?? false;
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  numberOnly(event): boolean {
    return this.commonCalculatorService.numberOnly(event);
  }

  handledblClick(event: any) {
    this.commonCalculatorService.handledblClick(event);
  }
  checkkeyedInTransaction() {
    this.keyedInTransaction = false;
    if (this.paymentForm.controls['paymentDetails'].value['keyedInTransaction'])
      this.keyedInTransaction = true;
  }

  getCreditCardFeeSettings() {
    this.creditCardTypeService.getCreditCardFeeSettings()
      .pipe(take(1)).subscribe(res => {
        if (res) {
          this.chargeCCProcessingFee = res.ChargeCCProcessingFee;
        }
      });
  }

  calculateConvenienceFee() {
    const pd = this.paymentForm.controls['paymentDetails'];
    if (this.chargeCCProcessingFee) {
      let convenienceFee = 0;
      const card = this.commonCalculatorService.getActualAmountFromInp(pd.get('creditCardAmount')?.value || 0);
      const cardIdSelected = pd.get('creditCards')?.value;
      const creditcardData = this.creditCardList.filter(e => e.CreditCardTypeId == cardIdSelected);
      if (creditcardData?.length && card > 0) {
        if (creditcardData[0].ChargeType?.includes('Percentage')) {
          convenienceFee = parseFloat((card * (creditcardData[0].Charge / 100)).toFixed(2));
        } else {
          convenienceFee = creditcardData[0].Charge ?? 0;
        }
      }
      convenienceFee = parseFloat(convenienceFee.toFixed(2));
      pd.get('convenienceFee')?.setValue(this.customCurrency.transform(convenienceFee.toString()), { emitEvent: false });
    } else {
      pd.get('convenienceFee')?.setValue(this.customCurrency.transform('0.00'), { emitEvent: false });
    }
    this.calculatePaymentDistribution();
  }

  checkPaymentType() {
    if (!this.IsStrip) {
      const cardTypeId = this.paymentForm.controls['paymentDetails'].get('creditCards')?.value;
      const cardType = this.creditCardList.find(e => e.CreditCardTypeId == cardTypeId)?.CreditCardType;
      this.transactionType = cardType?.toLowerCase() === 'credit card' ? 'CREDITSALE' : 'DEBITSALE';
      if (this.transactionType == "CREDITSALE") {
        this.paymentForm.controls['paymentDetails'].get('keyedInTransaction').enable();
      } else {
        this.paymentForm.controls['paymentDetails'].get('keyedInTransaction').disable();
        this.paymentForm.controls['paymentDetails'].get('keyedInTransaction').setValue(false);
      }
    } else {
      this.paymentForm.controls['paymentDetails'].get('keyedInTransaction').enable();
      this.paymentForm.controls['paymentDetails'].get('keyedInTransaction').setValue(false);
    }
    this.calculateConvenienceFee();
  }

  onReceiptToggle(receiptId: number, checked: boolean) {
    if (checked) {
      this.selectedIdsSet.add(receiptId);
    } else {
      this.selectedIdsSet.delete(receiptId);
    }
    this.applyReceiptFilter();
  }

  applyReceiptFilter() {
    if (this.selectedIdsSet.size === 0) {
      this.rentalDues = [];
      this.otherRentalDues = [];
      const totalDue = this.customCurrency.transform("0");
      this.paymentForm.controls['paymentDetails'].patchValue({
        totalDue: totalDue,
        balanceAmount: totalDue
      })
      return;
    }
    this.rentalDues = this.fullRentalDues.filter(x =>
      this.selectedIdsSet.has(x.MarketAccountReceiptId)
    );
    this.otherRentalDues = this.fullOtherRentalDues.filter(x =>
      this.selectedIdsSet.has(x.MarketAccountReceiptId)
    );

    let totalDueNumeric = this.rentalDues.reduce((sum, a) => {
      const due = this.commonCalculatorService.getActualAmountFromInp(a.Due ?? 0);
      const tax1 = this.commonCalculatorService.getActualAmountFromInp(a.Tax1 ?? 0);
      const tax2 = this.commonCalculatorService.getActualAmountFromInp(a.Tax2 ?? 0);
      return sum + due + tax1 + tax2;
    }, 0);

    totalDueNumeric += this.otherRentalDues.reduce((sum, a) => {
      const due = this.commonCalculatorService.getActualAmountFromInp(a.Due ?? 0);
      const tax1 = this.commonCalculatorService.getActualAmountFromInp(a.Tax1 ?? 0);
      const tax2 = this.commonCalculatorService.getActualAmountFromInp(a.Tax2 ?? 0);
      return sum + due + tax1 + tax2;
    }, 0);
    const totalDue = this.customCurrency.transform(totalDueNumeric);
    this.paymentForm.controls['paymentDetails'].patchValue({
      totalDue: totalDue,
      balanceAmount: totalDue
    })
  }

  calculatePaymentDistribution(formatValues: boolean = true): void {

    if (this.isRentalCashRoundingEnabled && !this.hasNonCashPayment() && !this.isCashModeActive) {
      // Re-enable rounding when only cash remains
      this.isCashModeActive = true;
    }

    const paymentDetails = this.paymentForm.get('paymentDetails');
    if (!paymentDetails) return;

    const cashCtrl = paymentDetails.get('cashAmount');
    const checkCtrl = paymentDetails.get('checkAmount');
    const creditCtrl = paymentDetails.get('creditCardAmount');
    const debitCtrl = paymentDetails.get('directDebitAmount');
    const applyCredit = this.shouldApplyExistingCredit();
    const creditAmount = paymentDetails.get('ExistingCredit');
    var existingCreditAmount = this.commonCalculatorService.getActualAmountFromInp(creditAmount?.value) || 0;

    const cash = +this.commonCalculatorService.getActualAmountFromInp(cashCtrl?.value) || 0;
    const check = +this.commonCalculatorService.getActualAmountFromInp(checkCtrl?.value) || 0;
    const credit = +this.commonCalculatorService.getActualAmountFromInp(creditCtrl?.value) || 0;
    const debit = +this.commonCalculatorService.getActualAmountFromInp(debitCtrl?.value) || 0;

    if (credit === 0) {
      paymentDetails.get('convenienceFee')?.setValue(this.customCurrency.transform('0.00'), { emitEvent: false });
    }

    if (cash === 0 && this.isCashModeActive) {
      this.isCashModeActive = false;

      this.paymentForm.get('paymentDetails.roundingAmount')?.setValue(this.customCurrency.transform("0"), { emitEvent: false });
    }

    var totalPayment = cash + check + credit + debit;

    if (this.isCashModeActive && this.isRentalCashRoundingEnabled) {
      const roundingAmount = Number(this.commonCalculatorService.getActualAmountFromInp(this.paymentForm.get('paymentDetails.roundingAmount')?.value)) || 0;
      totalPayment = Number((totalPayment - roundingAmount).toFixed(2));
    }

    if (check > 0)
      paymentDetails.get('checkNo').enable();
    else {
      paymentDetails.get('checkNo').disable();
      paymentDetails.get('checkNo').setValue('');
    }

    if (credit > 0) {
      paymentDetails.get('creditCards').enable();
      const cardTypeId = paymentDetails.get('creditCards')?.value;
      const cardType = this.creditCardList.find(e => e.CreditCardTypeId == cardTypeId)?.CreditCardType;
      this.transactionType = cardType?.toLowerCase() === 'credit card' ? 'CREDITSALE' : 'DEBITSALE';
      if (this.transactionType === 'CREDITSALE') {
        paymentDetails.get('keyedInTransaction')?.enable();
      } else {
        if (!this.IsStrip) {
          paymentDetails.get('keyedInTransaction')?.disable();
          paymentDetails.get('keyedInTransaction')?.setValue(false, { emitEvent: false });
        }
      }
    }
    else {
      paymentDetails.get('creditCards').setValue('1');
      paymentDetails.get('creditCards').disable();
      paymentDetails.get('keyedInTransaction')?.disable();
      paymentDetails.get('keyedInTransaction')?.setValue(false, { emitEvent: false });
    }

    let totalDue = 0;
    for (const record of this.rentalDues) {
      const due = this.commonCalculatorService.getActualAmountFromInp(record.Due);

      const sum = due;

      totalDue += Number(sum.toFixed(2)) || 0;
      record.Payment = "0";
    }

    for (const record of this.otherRentalDues) {
      const due = this.commonCalculatorService.getActualAmountFromInp(record.Due);
      const sum = due;

      totalDue += Number(sum.toFixed(2)) || 0;
      record.Payment = "0";
    }

    let changeAmount = 0;
    if (this.calculateChangeAmount && cash > 0 && totalDue > 0) {
      const nonCashPayment = check + credit + debit;
      const remainingCashDue = Math.max(0, Number((totalDue - nonCashPayment).toFixed(2)));
      if (cash > remainingCashDue) {
        changeAmount = Number((cash - remainingCashDue).toFixed(2));
        totalPayment = Number((totalPayment - changeAmount).toFixed(2));
      }
    }

    let balanceAmount = 0;
    let vendorBalance = 0;
    
    if (applyCredit && this.displayApplyCredit) {
       totalPayment = totalPayment + existingCreditAmount;
    }   
    balanceAmount = totalDue - totalPayment;    

    vendorBalance = balanceAmount;
    if (!applyCredit || (applyCredit && this.rentalData)) {
      vendorBalance = this.totalVendorBalance - totalPayment;
    }

    if (!this.rentalData && totalDue == 0 && existingCreditAmount != 0) {
      vendorBalance = this.totalVendorBalance - totalPayment;
    }

    if (!this.displayApplyCredit && applyCredit && totalDue != 0 && this.rentalData) {
      vendorBalance = this.totalVendorBalance - (totalPayment + existingCreditAmount);
    }

    let paidRemaining = totalPayment;
    let creditRemaining = 0;

    if (applyCredit) {
      creditRemaining = existingCreditAmount;
    }

    const distributePayment = (records: any[]) => {
      for (const record of records) {
        const due = +this.commonCalculatorService.getActualAmountFromInp(record.Due) || 0;
        if (paidRemaining <= 0 && creditRemaining <= 0) break;

        let paymentUsed = 0;
        let creditUsed = 0;

        // First apply paid amount
        if (paidRemaining > 0) {
          paymentUsed = Math.min(due, paidRemaining);
          paidRemaining -= paymentUsed;
        }

        // Remaining due after payment
        const balanceDue = due - paymentUsed;

        // Then apply credit
        if (creditRemaining > 0 && balanceDue > 0) {
          creditUsed = Math.min(balanceDue, creditRemaining);
          creditRemaining -= creditUsed;
        }

        record.Payment = this.customCurrency.transform(paymentUsed.toString());
        record.CrAmt = this.customCurrency.transform(creditUsed.toString());
      }
    };

    distributePayment(this.rentalDues);
    distributePayment(this.otherRentalDues);

    balanceAmount = this.normalizeMoney(balanceAmount);
    vendorBalance = this.normalizeMoney(vendorBalance);

    paymentDetails.get('balanceAmount')?.setValue(this.customCurrency.transform(balanceAmount.toString()), { emitEvent: false });
    paymentDetails.get('vendorBalance')?.setValue(this.customCurrency.transform(vendorBalance.toString()), { emitEvent: false });
    paymentDetails.get('changeAmount')?.setValue(this.customCurrency.transform(changeAmount.toString()), { emitEvent: false });

    //cashCtrl?.setValue(this.customCurrency.transform(cash.toString()), { emitEvent: false });
    if (formatValues) {
      cashCtrl?.setValue(this.customCurrency.transform(cash.toString()), { emitEvent: false });
    }

    checkCtrl?.setValue(this.customCurrency.transform(check.toString()), { emitEvent: false });
    creditCtrl?.setValue(this.customCurrency.transform(credit.toString()), { emitEvent: false });
    debitCtrl?.setValue(this.customCurrency.transform(debit.toString()), { emitEvent: false });

    this.rentalDues = [...this.rentalDues];
    this.otherRentalDues = [...this.otherRentalDues];
  }

  onCheckNumKeyPress(event: KeyboardEvent) {
    const allowedChars = /[a-zA-Z0-9]/;
    const key = event.key;
    if (event.key === 'Backspace' || event.key === 'Delete' || event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === '#') {
      return;
    }
    if (!key.match(allowedChars)) {
      event.preventDefault();
    }
  }

  getLoggedInUserData() {
    this.generalService.getLoggedInUserAndTerminal().pipe(take(1)).subscribe(res => {
      this.userId = res.UserId
    })
  }

  async savePayment() {
    if (this.dayendProcessedForToday) {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Day end process is already completed for today! Payments cannot be saved!!`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
      return false;
    }
    const pd = this.paymentForm.controls['paymentDetails'];
    const cashAmount = this.commonCalculatorService.getActualAmountFromInp(pd.get('cashAmount')?.value);
    const checkAmount = this.commonCalculatorService.getActualAmountFromInp(pd.get('checkAmount')?.value);
    const creditCardAmount = this.commonCalculatorService.getActualAmountFromInp(pd.get('creditCardAmount')?.value);
    const directDebitAmount = this.commonCalculatorService.getActualAmountFromInp(pd.get('directDebitAmount')?.value);
    const convenienceFee = this.commonCalculatorService.getActualAmountFromInp(pd.get('convenienceFee')?.value);
    const roundedAmt = this.commonCalculatorService.getActualAmountFromInp(pd.get('roundingAmount')?.value)
    const changeAmount = this.commonCalculatorService.getActualAmountFromInp(pd.get('changeAmount')?.value) ?? 0

    const totalAmountPaid = (cashAmount - changeAmount) + checkAmount + creditCardAmount + directDebitAmount + convenienceFee - roundedAmt;
    const totalRentalPayment = totalAmountPaid - convenienceFee;
    const totalDue = this.commonCalculatorService.getActualAmountFromInp(pd.get('totalDue')?.value);

    if (this.rentalData && totalRentalPayment > totalDue) {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Your total payment exceeds the total due`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
      return false;
    }

    this.saveRentalWithPayment();
  }

  saveRentalWithPayment() {
    const pd = this.paymentForm.controls['paymentDetails'];
    const cashAmount = this.commonCalculatorService.getActualAmountFromInp(pd.get('cashAmount')?.value);
    const checkAmount = this.commonCalculatorService.getActualAmountFromInp(pd.get('checkAmount')?.value);
    const creditCardAmount = this.commonCalculatorService.getActualAmountFromInp(pd.get('creditCardAmount')?.value);
    const directDebitAmount = this.commonCalculatorService.getActualAmountFromInp(pd.get('directDebitAmount')?.value);
    const convenienceFee = this.commonCalculatorService.getActualAmountFromInp(pd.get('convenienceFee')?.value);
    const changeAmount = this.commonCalculatorService.getActualAmountFromInp(pd.get('changeAmount')?.value);
    const totalDue = this.commonCalculatorService.getActualAmountFromInp(pd.get('totalDue')?.value);
    let balanceDue = this.commonCalculatorService.getActualAmountFromInp(pd.get('vendorBalance')?.value);

    const roundedAmt = this.commonCalculatorService.getActualAmountFromInp(pd.get('roundingAmount')?.value);
    const totalAmountPaid = cashAmount + checkAmount + creditCardAmount + directDebitAmount + convenienceFee - roundedAmt;
    const totalRentalPayment = totalAmountPaid - convenienceFee;
    const expectedBalance = totalDue - (totalRentalPayment - changeAmount);

    if (expectedBalance !== balanceDue) {
      balanceDue = expectedBalance;
      pd.get('balanceAmount')?.setValue(this.customCurrency.transform(balanceDue.toString()));
    }

    if (totalAmountPaid !== 0 || (this.shouldApplyExistingCredit() && this.commonCalculatorService.getActualAmountFromInp(pd.get('ExistingCredit').value) > 0)) {
      if (checkAmount > 0 && !pd.value['checkNo']) {
        Swal.fire({
          title: $localize`Warning`,
          text: $localize`Please enter the check#.`,
          icon: "warning",
          confirmButtonText: $localize`Ok`,
        }).then((result) => {
          if (result.value && this.checkNo) this.checkNo.nativeElement.focus();
        });
      } else if (creditCardAmount > 0 && !pd.value['creditCards']) {
        Swal.fire({
          title: $localize`Warning`,
          text: $localize`Please select the card type.`,
          icon: "warning",
          confirmButtonText: $localize`Ok`,
        });
      } else if (!(this.warnExcessPayment && totalRentalPayment > totalDue)) {
        Swal.fire({
          title: $localize`Confirm`,
          text: $localize`Are you sure you want to proceed with the payment?`,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: $localize`Yes`,
          cancelButtonText: $localize`No`,
        }).then((result) => {
          if (result.value) this.proceedWithPayment();
        });
      } else {
        this.proceedWithPayment();
      }
    } else {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Please enter the cash/card or check amount!`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
  }

  proceedWithPayment() {
    const pd = this.paymentForm.controls['paymentDetails'];
    const creditCardAmount = this.commonCalculatorService.getActualAmountFromInp(pd.get('creditCardAmount')?.value);
    const convenienceFee = this.commonCalculatorService.getActualAmountFromInp(pd.get('convenienceFee')?.value);

    this.disablePayBtnAfterSubmit = true;

    if (creditCardAmount > 0) {
      if (this.paymentGatewayCredentials && this.processCreditCardOnline) {
        this.processPayment = true;
        this.creditCardAmount = parseFloat((creditCardAmount).toFixed(2));
      } else {
        const obj = {
          PaymentSuccess: true,
          OrderId: "",
          VerifoneId: 0
        };
        this.PaymentResponse(obj);
      }
    } else {
      const obj = {
        PaymentSuccess: true,
        OrderId: "",
        VerifoneId: 0
      };
      this.PaymentResponse(obj);
    }
  }

  PaymentResponse(response) {
    this.loaderIcon = Promise.resolve(true);
    if (response.PaymentSuccess) {
      this.verifoneId = response.VerifoneId;
      if (this.rentalData) {
        switch (parseInt(this.rentalType)) {
          case 4:
            this.subscriptions.push(this.operationRentalService.saveCombinedMonthlyRental(this.rentalData).subscribe(async (res: any) => {
              if (res.Success) {
                if (res.Id !== 0) {
                  await this.updatePayByBoothDue(res.Id, response.OrderId)
                  this.toastr.success($localize`Transaction saved successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
                }
                else {
                  this.closePayByBooth.emit(true);
                }
              }
              else {
                if (this.verifoneId) {
                  this.processPayment = false;
                  this.voidPayment = true;
                }
                this.toastr.error($localize`Error occured while saving the rental transaction`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
              }
              this.loaderIcon = Promise.resolve(false);
            }, (err) => {
              this.toastr.error($localize`Error occured while saving the rental transaction`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
              this.closePayByBooth.emit(true);
            }));
            break;
        }
      }
      else {
        this.updatePayByBoothDue(0, response.OrderId);
      }
    }
    else {
      this.processPayment = false;
      this.voidPayment = false;
      this.disablePayBtnAfterSubmit = false;
      this.loaderIcon = Promise.resolve(false);
    }
  }

  getPaymentValue(controlName: string): number {
    const val = this.paymentForm.controls['paymentDetails'].get(controlName)?.value;
    return this.commonCalculatorService.getActualAmountFromInp(val);
  }

  cancelPayment() {
    Swal.fire({
      title: $localize`Confirm`,
      text: $localize`Are you sure you want to go back ?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,
    }).then((result) => {
      if (result.value) {
        this.cancelPayByBooth.emit(true);
      }
    });
  }

  async getRentalPrinterSettings(rentalType, paymentOnly) {
    this.loaderIcon = Promise.resolve(true);
    var res = await lastValueFrom(this.printerService.getRentalPrinterSettings())
    if (res) {
      this.paymentForm.patchValue
        ({
          displayReceipt: res.ReceiptDefaultChecked,
          printReceipt: res.PrintReceipt,
          emailReceipt: res.EmailReceipt
        })
      if (paymentOnly) {
        this.printThermalReceipt = res.PaymentThermal ?? false;
        this.thermalReceiptCopies = res.PaymentCopies ?? 0;
      } else {
        this.printThermalReceipt = rentalType == 4 ? res.MonthlyThermal : false;
        this.thermalReceiptCopies = rentalType == 4 ? res.MonthlyCopies : 0;
      }
      this.rentalMerchantCopy = res.RentalMerchantCopy ?? false;
      this.rentalMerchantNoOfCopies = res.RentalMerchantCopies ?? 0;
      this.rentalCustomerCopy = res.RentalCustomerCopy ?? false;
      this.rentalCustomerNoOfCopies = res.RentalCustomerCopies ?? 0;
    }
  }

  updatePayByBoothDue(accountReceiptId, paymentOrderId) {
    this.loaderIcon = Promise.resolve(true);
    const objDuesRecord = [];
    const paymentOnly = this.rentalData != null ? false : true;
    var priorBalance = 0;

    if (this.rentalDues.length > 0) {
      for (var item of this.rentalDues) {
        const due = this.commonCalculatorService.getActualAmountFromInp(item.Due);
        const payment = this.commonCalculatorService.getActualAmountFromInp(item.Payment);
        const paid = this.commonCalculatorService.getActualAmountFromInp(item.Paid);
        priorBalance += due;

        let chargeStatus = "P";
        if (payment === 0 && paid === 0) {
          chargeStatus = "U";
        } else if (payment >= due) {
          chargeStatus = "F";
        } else {
          chargeStatus = "P";
        }

        objDuesRecord.push({
          DueChargeDescription: 'Comb Monthly Rental',
          CurrentAmount: this.commonCalculatorService.getActualAmountFromInp(item.Rent),
          Tax1: this.commonCalculatorService.getActualAmountFromInp(item.Tax1),
          Tax2: this.commonCalculatorService.getActualAmountFromInp(item.Tax2),
          PriorBalance: 0,
          Deletion: false,
          Total: this.commonCalculatorService.getActualAmountFromInp(item.Due),
          PaidTill: this.commonCalculatorService.getActualAmountFromInp(item.Paid) + this.commonCalculatorService.getActualAmountFromInp(item.Payment ?? 0) + this.commonCalculatorService.getActualAmountFromInp(item.CrAmt ?? 0),
          ChargeType: 'R',
          RentalBoothOrOtherID: item.BoothNum,
          VendorId: this.vendorId,
          OtherBoothNumber: "",
          RentalPeriod: item.RentalPeriod,
          ChargeStatus: chargeStatus,
          AccountReceiptId: item.AccountReceiptId,
          RentalId: item.RentalId,
          CurrentPayment: this.commonCalculatorService.getActualAmountFromInp(item.Payment ?? 0)
        });
      }
    }

    if (this.otherRentalDues.length > 0) {
      for (var item of this.otherRentalDues) {
        const due = this.commonCalculatorService.getActualAmountFromInp(item.Due);
        const payment = this.commonCalculatorService.getActualAmountFromInp(item.Payment);
        const paid = this.commonCalculatorService.getActualAmountFromInp(item.Paid);
        priorBalance += due;

        let chargeStatus = "P";
        if (payment === 0 && paid === 0) {
          chargeStatus = "U";
        } else if (payment >= due) {
          chargeStatus = "F";
        } else {
          chargeStatus = "P";
        }
        objDuesRecord.push({
          DueChargeDescription: 'Comb Monthly Other',
          CurrentAmount: this.commonCalculatorService.getActualAmountFromInp(item.Rent),
          Tax1: this.commonCalculatorService.getActualAmountFromInp(item.Tax1),
          Tax2: this.commonCalculatorService.getActualAmountFromInp(item.Tax2),
          PriorBalance: 0,
          Deletion: false,
          Total: this.commonCalculatorService.getActualAmountFromInp(item.Due),
          PaidTill: this.commonCalculatorService.getActualAmountFromInp(item.Paid) + this.commonCalculatorService.getActualAmountFromInp(item.Payment ?? 0) + this.commonCalculatorService.getActualAmountFromInp(item.CrAmt ?? 0),
          ChargeType: 'O',
          RentalBoothOrOtherID: item.RentalBoothOrOtherID,
          VendorId: this.vendorId,
          OtherBoothNumber: "",
          RentalPeriod: item.RentalPeriod,
          ChargeStatus: chargeStatus,
          AccountReceiptId: item.AccountReceiptId,
          RentalId: item.RentalId,
          CurrentPayment: this.commonCalculatorService.getActualAmountFromInp(item.Payment ?? 0)
        });
      }
    }

    var vendorFinalBalance = this.getPaymentValue('vendorBalance');

    if(this.displayApplyCredit && !this.paymentForm.controls['paymentDetails'].get('applyCredit')?.value && this.rentalData){
      const existingCreditAmount = this.commonCalculatorService.getActualAmountFromInp(this.paymentForm.get('paymentDetails.ExistingCredit')?.value) || 0;
      vendorFinalBalance -= existingCreditAmount;
    }

    var obj = {
      VendorId: this.vendorId,
      AccountReceiptId: accountReceiptId,
      CashAmount: this.getPaymentValue('cashAmount') - this.getPaymentValue('roundingAmount'),
      CheckAmount: this.getPaymentValue('checkAmount'),
      CheckNo: this.paymentForm.controls['paymentDetails'].value['checkNo'],
      CardAmount: this.getPaymentValue('creditCardAmount'),
      DirectDebitAmount: this.getPaymentValue('directDebitAmount'),
      CardType: String(this.getPaymentValue('creditCards')),
      CCCharge: this.getPaymentValue('convenienceFee'),
      PaymentDone: true,
      ChangeAmount: this.getPaymentValue('changeAmount'),
      PaymentOrderId: paymentOrderId,
      VerifoneId: this.verifoneId,
      PaymentOnly: paymentOnly,
      DueRecordModel: objDuesRecord,
      RentalType: this.rentalType,
      BalanceDue: vendorFinalBalance,
      PriorBalance: priorBalance,
      RoundingAmount: this.getPaymentValue('roundingAmount'),
      CCChargeType : this.creditCardList.find(e => e.CreditCardTypeId == this.getPaymentValue('creditCards'))?.ChargeType ?? "",
      RentalNotes: (this.finalRentalNotes ?? '').trim()
    };

    this.subscriptions.push(this.operationRentalService.saveVendorRentalDues(obj).subscribe(async (res: any) => {
      const settings = this.paymentForm.value;
      if (settings.displayReceipt || settings.printReceipt || settings.emailReceipt) {
        await this.getRentalPrinterSettings(res.RentalType, paymentOnly);
        const hasCreditCardAmount = this.getPaymentValue('creditCardAmount') > 0;
        this.paymentCompleted.emit({
          receiptId: res.Id,
          rentalType: res.RentalType,
          showReceipt: settings.displayReceipt,
          print: settings.printReceipt,
          email: settings.emailReceipt,
          vendorId: this.vendorId,
          printThermal: this.printThermalReceipt,
          thermalReceiptCopies: this.thermalReceiptCopies,
          rentalMerchantCopy: hasCreditCardAmount ? this.rentalMerchantCopy ?? false : false,
          rentalMerchantNoOfCopies: hasCreditCardAmount ? this.rentalMerchantNoOfCopies ?? 0 : 0,
          rentalCustomerCopy: hasCreditCardAmount ? this.rentalCustomerCopy ?? false : false,
          rentalCustomerNoOfCopies: hasCreditCardAmount ? this.rentalCustomerNoOfCopies ?? 0 : 0,
        });
      } else {
        this.loaderIcon = Promise.resolve(false);
      }
      this.closePayByBooth.emit(true);
    }, err => {
      if (this.verifoneId) {
        this.processPayment = false;
        this.voidPayment = true;
      }
      this.loaderIcon = Promise.resolve(false);
      this.toastr.error($localize`Error occured while saving the rental transaction`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
    }));
  }

  voidPaymentResponse(response) {
    this.voidPayment = false;
    this.processPayment = false;
    this.disablePayBtnAfterSubmit = false;
    this.loaderIcon = Promise.resolve(false);
  }

  private roundToNearestNickel(amount: number): number {
    const cents = Math.round(amount * 100);
    const remainder = cents % 5;
    let roundedCents = cents;

    if (remainder !== 0) {
      if (remainder <= 2) {
        roundedCents = cents - remainder; //round down
      } else {
        roundedCents = cents + (5 - remainder); //round up
      }
    }

    return Number((roundedCents / 100).toFixed(2));
  }

  private applyCashRoundingIfEnabled(amount: number): number {
    if (this.isCashModeActive && this.isRentalCashRoundingEnabled) {
      const rounded = Number(this.roundToNearestNickel(amount).toFixed(2));
      const diff = Number((rounded - amount).toFixed(2));
      this.paymentForm.get('paymentDetails.roundingAmount')?.setValue(this.customCurrency.transform(diff.toFixed(2).toString()));
      return rounded;
    } else {
      this.paymentForm.get('paymentDetails.roundingAmount')?.setValue(
        this.customCurrency.transform("0")
      );
      return Number(amount.toFixed(2));
    }
  }

  activateCashRounding() {
    if (!this.isRentalCashRoundingEnabled) return;
    // Do NOt round if any non-cash payment exists
    if (this.hasNonCashPayment()) {
      return;
    }

    if (this.isCashModeActive) return;
    this.isCashModeActive = true;

    var totalDue = this.paymentForm.controls['paymentDetails'].get('totalDue').value;
    const dueAmount = Number(this.commonCalculatorService.getActualAmountFromInp(totalDue));
    const roundedAmount = this.applyCashRoundingIfEnabled(dueAmount);
    this.paymentForm.controls['paymentDetails'].get('cashAmount').setValue(this.customCurrency.transform(roundedAmount.toString()));

    this.calculatePaymentDistribution()
  }

  deactivateCashRounding() {
    if (!this.isCashModeActive) return;
    this.isCashModeActive = false;
    this.paymentForm.get('paymentDetails.roundingAmount')?.setValue(
      this.customCurrency.transform("0")
    );
    this.calculatePaymentDistribution()
  }

  hasNonCashPayment(): boolean {
    if (!this.isRentalCashRoundingEnabled) return;
    const pd = this.paymentForm.get('paymentDetails');

    const check = this.commonCalculatorService.getActualAmountFromInp(pd.get('checkAmount')?.value);
    const credit = this.commonCalculatorService.getActualAmountFromInp(pd.get('creditCardAmount')?.value);
    const debit = this.commonCalculatorService.getActualAmountFromInp(pd.get('directDebitAmount')?.value);
    const existingCredit = this.commonCalculatorService.getActualAmountFromInp(pd.get('ExistingCredit')?.value);

    return check > 0 || credit > 0 || debit > 0 || existingCredit > 0;
  }

  normalizeMoney(value: number): number {
    return Math.abs(value) < 0.01 ? 0 : Number(value.toFixed(2));
  }

  handleCashManualInput() {
    if (!this.isRentalCashRoundingEnabled) return;

    const pd = this.paymentForm.get('paymentDetails');
    const totalDue = this.commonCalculatorService.getActualAmountFromInp(pd.get('totalDue')?.value) || 0;

    const cash = this.commonCalculatorService.getActualAmountFromInp(pd.get('cashAmount')?.value) || 0;
    const check = this.commonCalculatorService.getActualAmountFromInp(pd.get('checkAmount')?.value) || 0;
    const credit = this.commonCalculatorService.getActualAmountFromInp(pd.get('creditCardAmount')?.value) || 0;
    const debit = this.commonCalculatorService.getActualAmountFromInp(pd.get('directDebitAmount')?.value) || 0;
    const applyCredit = pd.get('applyCredit')?.value;
    const existingCredit = applyCredit ? this.commonCalculatorService.getActualAmountFromInp(pd.get('ExistingCredit')?.value) || 0 : 0;

    const remainingCashDue = Number((totalDue - check - credit - debit - existingCredit).toFixed(2));

    // Round only the remaining cash portion
    const roundedRemaining = this.roundToNearestNickel(remainingCashDue);
    const roundingDiff = Number((roundedRemaining - remainingCashDue).toFixed(2));

    const isExactRoundedMatch = Math.abs(cash - roundedRemaining) < 0.001;

    if (isExactRoundedMatch) {
      this.isCashModeActive = true;

      pd.get('roundingAmount')?.setValue(
        this.customCurrency.transform(roundingDiff.toString()),
        { emitEvent: false }
      );
    } else {
      this.isCashModeActive = false;

      pd.get('roundingAmount')?.setValue(
        this.customCurrency.transform("0"),
        { emitEvent: false }
      );
    }

    this.calculatePaymentDistribution(false);
  }

  onCashBlur() {
    this.calculatePaymentDistribution(true);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
